import fromDtoToKpiSelection from 'dto/kpi/fromDtoToKpiSelection.dto';
import asArray from 'utils/arrays/asArray.util';
import { firstOf, secondOf } from 'utils/arrays/elements.util';
import sortArray from 'utils/arrays/sortedArray.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import transformObject from 'utils/objects/transformObject.util';

const L = logger('fromDtoToKpiSelectionsSetup'); // eslint-disable-line no-unused-vars

const comparator = (a, b) => (a?.order === b?.order ? 0 : Math.sign(a?.order - b?.order));

const fromDtoToSelectionsCardInfo = (dto) => {
  const isBusiness = !!dto?.isBusiness;
  const stylistId = dto?.stylistId || dto?.stylist_id || null;

  const transform = (item) => ({ ...fromDtoToKpiSelection(item), isBusiness, stylistId });

  return {
    isBusiness,
    stylistId,
    available: asArray(dto?.available_to_select).map(transform),
    selected: sortArray(comparator, asArray(dto?.selected_kpis).map(transform)),
  };
};

const fromStylistsDtoToStylistsObject = (entries) =>
  entries.map((entry) => {
    const stylistId = fromAnyToInteger(firstOf(entry));
    const cardInfo = secondOf(entry);
    return [stylistId, fromDtoToSelectionsCardInfo({ ...cardInfo, stylistId, isBusiness: false })];
  });

const fromDtoToKpiSelectionsSetup = (dto) => {
  const business = dto?.results?.business;
  const stylists = dto?.results?.stylists ?? {};

  return {
    business: business ? fromDtoToSelectionsCardInfo({ ...asObject(business), isBusiness: true }) : {},
    stylists: transformObject(fromStylistsDtoToStylistsObject, stylists),
  };
};

export default fromDtoToKpiSelectionsSetup;
